export default {
    cz: {
        rental: {
            ban: '<strong>Bohužel, tuto položku na Váš účet není možné objednat.</strong> Pro více informací kontaktujte Zákaznické centrum.',
        },
        errors: {
            notExisted: (title: string) => `Položka ${title} neexistuje nebo byla smazána.`,
            quantityMinimum: (title: string) => `${title} má zadáno menší než povolené minimální množství k objednání.`,
            quantityOutOfRange: (title: string) => `${title} má zadáno množství mimo povolený rozsah. (0,001 - 1000000)`,
            default: (code: string) => `Nastala chyba při přidávání položky do košíku. Kód chyby: ${code}`,
        },
    },
    sk: {
        rental: {
            ban: '<strong>Bohužiaľ, túto položku na Váš účet nie je možné objednať.</strong> Pre viac informácií kontaktujte Zákaznícke centrum.',
        },
        errors: {
            notExisted: (title: string) => `Položka ${title} neexistuje alebo bola zmazaná.`,
            quantityMinimum: (title: string) => `${title} má zadané menšie než povolené minimálne množstvo na objednávanie.`,
            quantityOutOfRange: (title: string) => `${title} má zadané množstvo mimo povolený rozsah. (0,001 - 1000000)`,
            default: (code: string) => `Nastala chyba pri ukladaní položky do košíka. Kód chyby: ${code}`,
        },
    },
}
